// import "./ThankYouPage.scss"
import { useEffect } from 'react';

import { addDays, format, setDay } from 'date-fns';
import { useSelector } from 'react-redux';

// import SingleInputPage from "../SingleInputPage/SingleInputPage";
// import Button from "../../Button/Button";
// import ThankYouText from "../../ThankYouText/ThankYouText";
import LoadingBar from '../../LoadingBar/LoadingBar';

export default function ThankYouPage({status}) {
  // const currentPage = useSelector(store => store.state.page)
  // const thankYou = useSelector(store => store.data.thankYou)
  // const thankYouTitle = useSelector(store => store.data.thankYouTitle)
  // const thankYouDescriptionF = useSelector(store => store.data.thankYouDescriptionF)
  // const thankYouDescriptionS = useSelector(store => store.data.thankYouDescriptionS)

  const text = useSelector(
    (store) => 'GO4Robot - ' + store.state.service?.title,
  );
  const showLessonTime = useSelector(
    (store) => store.state.occurrence?.show_lesson_time,
  );
  const cyclicDay = useSelector((store) => store.state.occurrence?.cyclic_day);
  const cyclicHour = useSelector(
    (store) => store.state.occurrence?.cyclic_hour,
  );
  const duration = useSelector((store) => store.state.robot?.duration);
  const location = useSelector(
    (store) => store.state.occurrence?.physical_address,
  );
  const details = useSelector(
    (store) => store.state.robot?.description_secondary,
  );
  const city = useSelector((store) => store.state.city?.franchise.slug);
  
  let datestart = null;
  if (cyclicDay && cyclicHour) {
    const hourSemicolon = cyclicHour.indexOf(':');
    const hour = cyclicHour.substring(0, hourSemicolon);
    const minutes = cyclicHour.substring(hourSemicolon + 1, cyclicHour.length);
    const correctHour = new Date();
    correctHour.setHours(+hour);
    correctHour.setMinutes(+minutes);
    correctHour.setSeconds(0);
    correctHour.setMilliseconds(0);
    let correctDay = setDay(correctHour, +cyclicDay % 7); // takes 0-6 0-sunday, we have 1-7, 1-monday
    //it will take day in week - (past or future)

    if (correctDay <= new Date()) {
      correctDay = addDays(correctDay, 7);
    }
    datestart = correctDay;
  }

  // if showlessontime(start) is in future
  if (showLessonTime && new Date() < new Date(showLessonTime)) {
    datestart = new Date(showLessonTime);
  }

  // const content = (
  //     <div className="ThankYouPage-container">
  //         <div className="ThankYouPage-wrapper-top">
  //             <div className="ThankYouPage-title-wrapper">
  //                 <div className="ThankYouPage-thankyou">
  //                     <ThankYouText text={thankYou} size={'36px'}/>
  //                 </div>
  //                 <div className="ThankYouPage-thankyou-title">
  //                     <ThankYouText text={thankYouTitle} size={'18px'}/>
  //                 </div>
  //             </div>
  //             <div className="ThankYouPage-description">
  //                 <ThankYouText text={thankYouDescriptionF} size={'14px'}/>
  //                 <ThankYouText text={thankYouDescriptionS} size={'14px'}/>
  //             </div>
  //         </div>
  //         <div className="ThankYouPage-wrapper-bottom">
  //             <div className="ThankYouPage-image">
  //             <img className="ThankYouPage-img" src='/assets/images/robot.png' alt="robot"/>
  //             </div>
  //             <div className="ThankYouPage-button">
  //                 <div className="ThankYouPage-button-wrapper">
  //                     <div className="ThankYouPage-margin-top">
  //                         <ThankYouText text={'Zespół GO4ROBOT'} size={'14px'}/>
  //                     </div>
  //                     {datestart &&
  //                         <div className="ThankYouPage-margin-button">
  //                             <Button
  //                                 type={'primary-bigger'}
  //                                 text={'Dodaj do kalendarza'}
  //                                 onClick={() => window.open(Calendar(text,datestart,duration,location,details),'_blank')}
  //                             />
  //                         </div>
  //                     }
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  // )

  // return(
  //     <div style={{position: 'relative', overflow: 'hidden'}}>
  //         <img className="ThankYouPage-mark" src='/assets/images/mark.png' alt="mark"/>
  //         <SingleInputPage
  //             page={currentPage}
  //             noProgressBar
  //             noTiles
  //             content={content}
  //             backButton={false}
  //             nextButton={false}
  //         />
  //     </div>
  // )

  useEffect(() => {
    const calendarLink =
      datestart && Calendar(text, datestart, duration, location, details);
    const host = `https://go4robot.pl/dziekujemy`;
    const params = new URLSearchParams();
    if (status) {
        params.append('status', status);
    }
    if (datestart) {
        params.append('calendar_link', calendarLink);
    }
   const cityPath = city && city !== 'poznan' ? `/${city}` : '';

    const link = `${host}${cityPath}?${params.toString()}`;
    window.location.replace(link);
  });

  return <LoadingBar wholePage />;
}

const Calendar = (text, datestart, duration, location, details) => {
  duration = duration.match(/\d+/)[0];
  let dateend = new Date(datestart);
  dateend.setHours(
    dateend.getHours(),
    dateend.getMinutes() + Number(duration),
    0,
    0,
  );

  datestart = format(datestart, "yyyyMMdd'T'HHmmSSXXX");
  dateend = format(dateend, "yyyyMMdd'T'HHmmSSXXX");

  let link = `https://calendar.google.com/calendar/r/eventedit?text=${text}%26location=${location}%26details=${details}%26dates=${datestart}/${dateend}`;

  return link;
};
